import { defineStore } from 'pinia';
import { isAudioDevicePreferences, type AudioDevicePreferences } from '@calloneer/contracts';

const STORAGE_KEY = 'calloneer.audio.v1';
const defaults: AudioDevicePreferences = {
  inputId: null,
  outputId: null,
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};

const loadPreferences = (): AudioDevicePreferences => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null');
    return isAudioDevicePreferences(parsed) ? parsed : defaults;
  } catch {
    return defaults;
  }
};

export const useAudioStore = defineStore('audio', {
  state: (): { preferences: AudioDevicePreferences } => ({ preferences: loadPreferences() }),
  actions: {
    save(preferences: AudioDevicePreferences): void {
      if (!isAudioDevicePreferences(preferences)) throw new TypeError('Invalid audio preferences');
      this.preferences = preferences;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    },
  },
});
